import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

export const PATH_V3_PERSONS_INVITATION = "/v3/persons/invitation";

export const routeHelpersV3PersonsInvitation = createRouteHelpers<
  never,
  { search: { inviteToken?: string } }
>(PATH_V3_PERSONS_INVITATION);
